import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, Menu, MenuItem, makeStyles } from '@cicero/ui'
import { StoreContext } from '../models/services'
import { UserTile } from './UserTile'

export const UserContextMenu = () => {
  const { userMenuWrapper } = styles()
  const history = useHistory()
  const location = useLocation()
  const store = useContext(StoreContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const { session } = store

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const navigate = (path: string) => {
    history.push(path)
    handleClose()
  }

  useEffect(() => {
    if (store) {
      store.API.registerApiHandler(401, (response) => { history.push(`/login?redirect=${location.pathname}`); return response })
    }
  }, [store, history])

  return (
    <div className={userMenuWrapper}>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <UserTile id={session?.user.id} noPad />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => navigate(`/${session?.url.path}`)}>Profile</MenuItem>
        <MenuItem onClick={() => navigate('/settings')}>Settings</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleClose}>Logout</MenuItem>
      </Menu>
    </div>
  )
}

const styles = makeStyles({
  userMenuWrapper: {
    padding: '16px 0',
  },
})
